<section class="impressum">
  <h1>Impressum</h1>

  <p><strong>Angaben gemäß § 5 TMG</strong></p>
  <p>
    CloudFusion IT UG (haftungsbeschränkt)<br />
    An der Mergelkuhle 6<br />
    37539 Bad Grund<br />
    Deutschland
  </p>

  <p><strong>Vertreten durch:</strong><br />Hüseyin Korkut (Geschäftsführer)</p>

  <p><strong>Kontakt:</strong><br />
    Telefon: <a href="tel:+491632723457">+49 163 2723457</a><br />
    E-Mail: <a href="mailto:korkut&#64;cloudfusion-it.de">korkut&#64;cloudfusion-it.de</a>
  </p>

  <p><strong>Registereintrag:</strong><br />
    Eingetragen im Handelsregister beim Amtsgericht Göttingen<br />
    Registernummer: HRB 207742
  </p>

  <p><strong>Umsatzsteuer-ID:</strong><br />
    Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: <em>DE452722726</em>
  </p>

  <p><strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong><br />
    Hüseyin Korkut<br />
    Anschrift wie oben
  </p>

  <h2>Haftungsausschluss</h2>

  <p><strong>Haftung für Inhalte</strong><br />
    Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
    Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
  </p>

  <p>
    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
    Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen entfernen wir diese Inhalte umgehend.
  </p>

  <p><strong>Haftung für Links</strong><br />
    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
    Deshalb übernehmen wir für diese fremden Inhalte auch keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
    Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
  </p>

  <h2>Urheberrecht</h2>

  <p>
    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht.
    Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts
    bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
  </p>
</section>
